import { graphql } from 'react-relay';

export const providersQuery = graphql`
    query providerQueryQuery {
        apiKey {
            clientId
            autoConfirmOrders
            descriptionKey
            id
            providerId
            secretKey
            statusId
            printfulPrefix
            printfulSuffix
            invitionPhoneNumber
        }
    }
`;

export const addQuery = graphql`
    mutation providerQueryAddMutation($input: ProviderApiKeyAddInput!) {
        addApiKey(input: $input) {
            providerId
            secretKey
            descriptionKey
            autoConfirmOrders
            clientId
            id
            printfulPrefix
            printfulSuffix
            invitionPhoneNumber
        }
    }
`;

export const deleteQuery = graphql`
    mutation providerQueryDeleteMutation($id: ID!) {
        deleteApiKey(id: $id) {
            clientId
            autoConfirmOrders
            descriptionKey
            id
            providerId
            secretKey
            statusId
        }
    }
`;
